import React, { useState, useRef, useEffect } from "react"
import { Document, Page, pdfjs } from "react-pdf"
import {
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/outline"

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url,
).toString()

const PdfRender = props => {
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)
  const [documentWidth, setDocumentWidth] = useState(null)
  const [canvasWidth, setCanvasWidth] = useState(null)
  const [firstPageBtn, setFirstPageBtn] = useState(true)
  const [prevPageBtn, setPrevPageBtn] = useState(true)
  const [nextPageBtn, setNextPageBtn] = useState(true)
  const [lastPageBtn, setLastPageBtn] = useState(true)
  const canvasRef = useRef(null)
  const canvasWrapperRef = useRef(null)

  useEffect(() => {
    if (numPages === 1) {
      setFirstPageBtn(true)
      setPrevPageBtn(true)
      setNextPageBtn(true)
      setLastPageBtn(true)
    }
    if (numPages > 1 && pageNumber === 1) {
      setFirstPageBtn(true)
      setPrevPageBtn(true)
      setNextPageBtn(false)
      setLastPageBtn(false)
    }
    if (numPages > 1 && pageNumber > 1) {
      setFirstPageBtn(false)
      setPrevPageBtn(false)
      setNextPageBtn(false)
      setLastPageBtn(false)
    }
    if (numPages > 1 && pageNumber === numPages) {
      setFirstPageBtn(false)
      setPrevPageBtn(false)
      setNextPageBtn(true)
      setLastPageBtn(true)
    }
  }, [pageNumber, numPages])

  const onDocumentLoadSuccess = ({ numPages }) => {
    setDocumentWidth(canvasWrapperRef.current.clientWidth)
    setNumPages(numPages)
  }

  const onPageLoadSuccess = () => {
    setCanvasWidth(documentWidth)
    // canvasRef.current.width = canvasWidth
  }

  return (
    <>
      <Document
        className="mx-auto overflow-hidden rounded-md shadow"
        file={props.file}
        inputRef={canvasWrapperRef}
        onLoadSuccess={onDocumentLoadSuccess}
      >
        <Page
          className="h-full w-full"
          pageNumber={pageNumber}
          renderAnnotationLayer={false}
          renderTextLayer={false}
          canvasRef={canvasRef}
          canvasBackground="white"
          width={canvasWidth}
          onLoadSuccess={onPageLoadSuccess}
        />
      </Document>

      <div className="mx-auto mt-4 flex items-center justify-center">
        <PageBtn disabled={firstPageBtn} onClick={() => setPageNumber(1)}>
          <ChevronDoubleLeftIcon className="h-4 w-4" />
        </PageBtn>

        <PageBtn
          disabled={prevPageBtn}
          onClick={() => setPageNumber(pageNumber - 1)}
        >
          <ChevronLeftIcon className="h-4 w-4" />
        </PageBtn>

        <span className="border border-b-0 border-t-0 border-slate-400 px-4 text-xs text-slate-600">
          Page {pageNumber} of {numPages}
        </span>

        <PageBtn
          disabled={nextPageBtn}
          onClick={() => setPageNumber(pageNumber + 1)}
        >
          <ChevronRightIcon className="h-4 w-4" />
        </PageBtn>

        <PageBtn disabled={lastPageBtn} onClick={() => setPageNumber(numPages)}>
          <ChevronDoubleRightIcon className="h-4 w-4" />
        </PageBtn>
      </div>
    </>
  )
}

const PageBtn = props => {
  return (
    <button
      className="text-slate-600 disabled:text-slate-300"
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  )
}

export default PdfRender
